import { createAction } from '../../libs/saga-utils';

const ns = 'printers';

export const PRINTERS_TYPES = {
  LOAD_PRINTERS: `${ns}/LOAD_PRINTERS`,
  LOAD_PRINTERS_SUCCESS: `${ns}/LOAD_PRINTERS_SUCCESS`,
  LOAD_PRINTERS_FAILURE: `${ns}/LOAD_PRINTERS_FAILURE`,
  SET_PRINTER_FOR_DAY: `${ns}/SET_PRINTER_FOR_DAY`
};

export const PRINTERS_ACTIONS = {
  loadPrinters: createAction(PRINTERS_TYPES.LOAD_PRINTERS, () => ({})),
  loadPrintersSuccess: createAction(
    PRINTERS_TYPES.LOAD_PRINTERS_SUCCESS,
    printers => ({ printers })
  ),
  loadPrintersFailure: createAction(
    PRINTERS_TYPES.LOAD_PRINTERS_FAILURE,
    error => ({ error })
  ),
  setPrinterForDay: createAction(
    PRINTERS_TYPES.SET_PRINTER_FOR_DAY,
    (periodId, day, printerName) => ({
      periodId,
      day,
      printerName
    })
  )
};
